"use client";
import React, { useId } from "react";
import { Button } from "@/components/Button";
import { SubmitHandler, useForm } from "react-hook-form";
import LoadingSpinner from "@/components/Common/LoadingSpinner";
import { getCookie, setCookie } from "cookies-next";
import axios from "axios";
import { useTranslations } from "next-intl";
import { message } from "antd";
import { UserLoginInfo, useUserStore } from "@/store/user.store";
import { useUserAuth } from "@/lib/hooks/useUserAuth";
import { useRouter } from "@/navigation";

type FormValues = {
	email?: string;
	password?: string;
	remember?: boolean;
	onSubmit: (data?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
	setLoginModalOn?: any;
};

interface LoginFormProps {
	setLoginModalOn?: any;
}

const LoginForm = ({ setLoginModalOn }: LoginFormProps) => {
	const t = useTranslations();
	const { setUserLoginInfo } = useUserStore();
	const emailId = useId();
	const passwordId = useId();
	let get_form_info: any = getCookie("created__user__info");
	if (get_form_info) {
		get_form_info = JSON.parse(get_form_info);
	}
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm<FormValues>();

	const [loading, setLoading] = React.useState(false);
	const { useLogin } = useUserAuth();
	const router = useRouter();
	const onSubmit: SubmitHandler<FormValues> = async (data: any) => {
		if (loading) return; // 防止重复提交
		
		setLoading(true);

		try {
			await useLogin(data);
			setLoginModalOn(false);
			// router.replace("/");
		} catch (e: any) {
			console.error('Login error:', e);
			message.error(e?.message || "登录失败，请重试");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div>
			<div className="user mt-7">
				<form action="" onSubmit={handleSubmit(onSubmit)}>
					<input
						type="text"
						id={emailId}
						autoComplete="email"
						className={`w-full rounded-sm border bg-white px-5 py-3 text-xl  !text-black outline-none placeholder:text-lg ${
							errors.email ? "border-red-500" : "border-themeSecondary300"
						}`}
						defaultValue={get_form_info?.email}
						placeholder={t("form.109a2790cc6b48461908f883b7b41549f9b3")}
						{...register("email", { required: true })}
					/>
					<input
						type="password"
						id={passwordId}
						autoComplete="current-password"
						className={`mt-6 w-full rounded-sm border bg-white px-5 py-3  text-xl !text-black outline-none placeholder:text-lg ${
							errors.password ? "border-red-500" : "border-themeSecondary300"
						}`}
						placeholder={t("common.Password")}
						{...register("password", { required: true })}
					/>

					<Button
						htmlType="submit"
						className={`mt-6 flex w-full items-center justify-center gap-4 !rounded-sm !bg-black ${
							loading ? "bg-themeSecondary800" : ""
						}`}
						disabled={loading}
					>
						{loading ? (
							<>
								<LoadingSpinner color="#fff" size={25} />
								<span>{t("message.7f9e518a7a1d1e4bc3e8990bed1d9be4d404")}...</span>
							</>
						) : (
							<span>{t("common.Sign_in")}</span>
						)}
					</Button>
				</form>
			</div>
		</div>
	);
};

export default LoginForm;
